import React, {KeyboardEvent} from 'react';
import {InputText, InputTextProps} from "primereact/inputtext";
import { Button } from 'primereact/button';
import { Value } from 'sass';

export type TawreedInputSearchProps = InputTextProps & { onEnterPressed?: (value: any) => void };

export const TawreedInputSearch: React.FC<TawreedInputSearchProps> = (props) => {

    const [state, setState] = React.useState<any>(props.value ?? props.defaultValue ?? '');

    function onKeyPress(e: KeyboardEvent<HTMLInputElement>): void {
        const value = (e.target as HTMLInputElement).value;
        if (e.key === 'Enter') {
            onValueChange(value);
        }
    }

    function onChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const value = e.target.value;
        setState(value);
        if (value === '') {
            onValueChange('');
        }
    }

    function onValueChange(e: string) {
        if (props.onEnterPressed) {
            props.onEnterPressed(e);
        }
    }
    const search = ()=>{
        if(state && props.onEnterPressed)
        {
            props.onEnterPressed(state!);
        }
    }

    return (
    <React.Fragment>
        <InputText className={props.className} 
            id={props.name}
            name={props.name}
            type={props.type}
            placeholder={props.placeholder}
            value={state} 
            style={props.style}
            onKeyPress={onKeyPress} onChange={onChange} autoComplete={props.autoComplete}/>
            <Button icon="pi pi-search" className="p-button-outlined flex-grow-1 bt-search" onClick={()=>{search()}} />
        </React.Fragment>
    )
}
